<template>
  <div>
    <!--pc-->
     <div v-if="!$flag">
        <div class="m-r-10 m-b-20 m-t-20 ">
          <el-row :gutter="10" class="m-t-20 levelInfo fs-14" type="flex" justify="space-between">
            <el-col :span="5" >
              <el-card class="box-card" shadow="never"  >
                <div class="clearfixed m-t-7" style="display:flex;">
                  <div class="pull-left m-t-5" style="flex: 0 0 50px;">
                    <img
                      :src="$tool.src(userInfo.head)"
                      style="width:50px;height:50px;border-radius:50%;"
                    />
                  </div>
                  <div class="text-center pull-left m-l-20" style="    flex: 1;
        margin-left: 0;" >
                    <div style="white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;">
                      <p
                        class="d-inline m-r-5"

                      >{{userInfo.discern==1? $t('user_Index_YRZ') : userInfo.discern==2 ?$t('user_Index_WRZ'):$t('user_Index_WSC')}}</p>
                      <img v-if="userInfo.discern==2" src="../../../assets/images/wrz.png" alt />
                      <img v-if="userInfo.discern==1" src="../../../assets/images/rz.png" alt />
                      <span style="margin-left:10px;font-size: 18px;color: #fa7202;">{{userInfo.score_order}}分</span>
                    </div>

                    <!-- 账户等级 -->
                    <!-- <p class="m-t-10">{{$t('user_Index_ZHDJ')}}</p> -->
                    <el-button
                      size="mini"
                      style="margin-top:22px;"
                      type="primary"
                      @click="$router.push('/insp/accountManage')"
                    >{{userInfo.discern==0?$t('user_Index_QWSXX'):$t('user_Index_QZHSZ')}}</el-button>
                  </div>
                </div>
              </el-card>
            </el-col>
            <el-col :span="5">
              <el-card class="box-card" shadow="never">
                <div class="clearfixed m-t-7" style="margin-top: 0px;">
                  <!-- <div class="pull-left m-t-10">
                    <img src="../../../assets/images/level.png" width="40" />
                  </div>-->
                  <div class="text-center">
                    <div class="fs-26 org">
                      {{userInfo.amount_type==1?'￥':'$'}}
                      <span @click="$router.push('/insp/fundManage?tab=2')">{{userInfo.amount_type==1?userInfo.amount:userInfo.us_amount}}</span>
                       <!-- 冻结金额 -->
                        <p class="fs-12 text-grey" @click="$router.push('/insp/fundManage?tab=2')">
                          ({{$t('djje')}}{{userInfo.amount_type==1?'￥':'$'}}{{userInfo.amount_type==1?userInfo.frozen_amount:userInfo.frozen_us_amount}})</p>
                    </div>
                    <div style="padding-top: 10px; color: #999;">{{$t('备注')}}：{{$t('APP内可申请提现')}}</div>
                    <!-- <div class="m-t-5">
                      <el-button
                        type="info"
                        size="mini"
                        @click="cashDialog=true"
                        plain
                      >{{$t('user_Index_TXSQ')}}</el-button>
                      <el-button
                        type="info"
                        size="mini"
                        @click="getuserInfo('open')"
                        plain
                        style="margin-left:5px"
                      >{{$t('user_Index_TXFS')}}</el-button>
                    </div> -->
                  </div>
                </div>
              </el-card>
            </el-col>
            <el-col :span="5">
              <el-card class="box-card hover" shadow="never"  @click.native="gradeVis=true">
                <div class="clearfixed m-t-7 cursor-pointer ">
                  <div class="pull-left m-t-10">
                    <img src="../../../assets/images/level.png" width="40" />
                  </div>
                  <div class="text-center pull-left m-l-20">
                    <p class="fs-26 org hover" v-bind:style="{color:userInfo.grade>=0?'#cc0000':'#01a100'}">{{Math.abs(userInfo.grade)}}</p>
                    <!-- 账户等级 -->
                    <p class="m-t-10 hover">{{$t('user_Index_ZHDJ')}}</p>
                  </div>
                </div>
              </el-card>
            </el-col>
            <el-col :span="5">
              <el-card class="box-card hover" shadow="never" @click.native="getTableData(),integralVis=true">
                <div class="clearfixed m-t-7 cursor-pointer" >
                  <div class="pull-left m-t-10">
                    <img src="../../../assets/images/jifen.png" width="40" />
                  </div>
                  <div class="text-center pull-left m-l-20">
                    <p class="fs-26 org hover">{{userInfo.integral}}</p>
                    <!-- 账户积分 -->
                    <p class="m-t-10 hover">{{$t('user_Index_ZHJF')}}</p>
                  </div>
                </div>
              </el-card>
            </el-col>
            <el-col :span="5">
              <el-card class="box-card hover" shadow="never" @click.native="toApplyRecod">
                <div class="clearfixed m-t-7">
                  <div class="pull-left m-t-10">
                    <img src="../../../assets/images/xinyong.png" width="40" />
                  </div>
                  <div class="text-center pull-left m-l-20" style="    vertical-align: middle;
        width: 60%;">
                    <p class="fs-26 org hover" >{{userInfo.insp_count}}</p>
                    <!-- 申请次数 -->
                    <p class="m-t-10 cursor-pointer hover"  style='    text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;'>{{$t('user_Index_SQCS')}}</p>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
        <div class="m-b-10" style="position:relative;">
          <sub-menu :dataSource="menus" @click="changeRouter" />
          <el-button
            type="primary"
            @click="seeYhY = true;getTableData1()"
            style="float: right;position: absolute;right: 20px;top: 8px;"
          >{{$t('map')}}</el-button>
        </div>
        <!-- 等级 -->
        <el-dialog v-dialogDrag :title="$t('user_Index_WDDJ')" v-if="gradeVis" :visible.sync="gradeVis" width="550px">
          <div class="m-b-20">
            <span class="fs-18 fw-600">
              {{$t('user_Index_WDDJS')}}
              <span class="org" v-bind:style="{color:userInfo.grade>=0?'#cc0000':'#01a100'}">{{Math.abs(userInfo.grade)}}</span>
              {{$t('user_Index_J')}}
            </span>
          </div>
          <div class="clearfixed">
            <span class="w-100 pull-left">{{$t('user_Index_DJHSGZ')}}</span>
            <div class="bg-grey p-30 w-400 pull-left">
              <div>
                <p>
                  <span class="w-80 d-inline-block">{{$t('user_Index_WDJF')}}</span>
                  <span class="w-12 d-inline-block">+</span>
                  <span class="w-80 d-inline-block">{{$t('user_Index_WDYE')}}</span>
                  <span class="w-30 d-inline-block">≥ 2ⁿ</span>
                  <span class="m-l-30">{{$t('user_Index_NWDJYH')}}</span>
                </p>
                <p class="fs-18 borwn m-t-20 m-b-20 fw-600">
                  <span class="w-80 d-inline-block text-center">{{userInfo.integral}}</span>
                  <span class="w-12 d-inline-block"></span>
                  <span class="w-80 d-inline-block text-center">${{userInfo.us_amount}}</span>
                  <span class="w-30 d-inline-block"></span>
                </p>
                <p>
                  <span class="w-80 d-inline-block text-center">{{userInfo.integral}}</span>
                  <span class="w-12 d-inline-block">+</span>
                  <span class="w-80 d-inline-block text-center">{{userInfo.us_amount}}</span>
                  <span class="w-60 d-inline-block" style="width:50px;">≥ 2^{{userInfo.grade}}</span>
                  <span class="m-l-30">{{$t('user_Index_DJW1')}}{{userInfo.grade}}</span>
                </p>
              </div>
            </div>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="gradeVis=false">{{$t('user_Index_QD')}}</el-button>
          </div>
        </el-dialog>
        <!-- 积分 -->
        <el-dialog
          v-dialogDrag
          :title="$t('user_Index_JFMX')"
          :visible.sync="integralVis"
          width="800px"
          v-if="integralVis"
        >
          <div class="m-b-20">
            <span class="fs-14 fw-600 m-l-20">
              {{$t('user_Index_PTJFGZ')}}
              <span class="org">{{userInfo.score}}</span>
              {{$t('user_Index_F')}},{{$t('user_Index_CGTJXYH')}}
              <span
                class="org"
              >{{userInfo.Invitation}}</span>
              {{$t('user_Index_F')}}
            </span>
          </div>
          <el-table
            :data="integralData"
            class="table"
            :header-cell-style="tableBG"
            highlight-current-row
          >
            <el-table-column :label="$t('user_Index_DDH')" prop="orders_num">
              <template slot-scope="scope">
                <router-link
                  tag="a"
                  class="text-blue"
                  target="_blank"
                  v-if="scope.row.type == 1"
                  :to="{path:'orderManage/editDetail',query:{id:scope.row.order_id}}"
                >{{scope.row.orders_num}}</router-link>
                <span v-else>{{scope.row.orders_num}}</span>
              </template>
            </el-table-column>
            <!-- 积分操作 -->
            <el-table-column :label="$t('payTip_jfChange')" prop="amount"></el-table-column>
            <!-- 创建时间 -->
            <el-table-column :label="$t('date')" prop="create_at">
              <template slot-scope="scope">
                <span>{{scope.row.create_at|setData}}</span>
              </template>
            </el-table-column>
            <!-- 账户积分 -->
            <el-table-column :label="$t('user_Index_BZ')" prop="remark"></el-table-column>
          </el-table>
          <el-pagination
            v-if="page_total!=0"
            class="m-20 text-right"
            :page-size="page_size"
            :page-sizes="page_size_opts"
            :total="page_total"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="page_current"
            @current-change="pageChange"
            @size-change="pageSizeChange"
          ></el-pagination>
        </el-dialog>

        <el-table
          :data="tableData"
          style="width: 99%"
          class="border"
          :header-cell-style="tableBG"
          highlight-current-row
        >
          <!-- 下单时间 -->
          <el-table-column prop="add_time" :label="$t('user_Index_XDSJ')" :width="yuyan=='en'?90:70"></el-table-column>
          <!-- 订单号 -->
          <el-table-column prop="orders_num" :label="$t('user_Index_DDH')" min-width="130">
            <template slot-scope="{ row }">
              <span class="cursor-pointer">{{row.orders_num}}</span>
            </template>
          </el-table-column>
          <!-- 验货类型 -->
          <el-table-column prop="type" :label="$t('user_Index_YHLX')" min-width="70">
            <template
              slot-scope="{ row }"
            >{{row.type==1?$t('user_Index_CJ'):row.type==2?$t('user_Index_QJ'):row.type==3?$t('user_Index_ZXJY'):row.type==4?$t('user_Index_YC'):row.type==5?$t('user_Index_JG'):$t('user_Index_YH+JG')}}</template>
          </el-table-column>
          <!-- 验货时间 -->
          <el-table-column prop="inspect_time" :label="$t('user_Index_YHSJ')" min-width="90"></el-table-column>
          <!-- 产品名称 -->
          <el-table-column prop="products" :label="$t('user_Index_CPMC')" min-width="70">
            <template slot-scope="{ row }">
              <span
                v-for="(item,index) in row.products"
                :key="index"
              >{{index!==row.products.length-1? item.product_name?item.product_name:'N/A'+',':item.product_name?item.product_name:'N/A'}}</span>
              <span v-if="row.products.length == 0">N/A</span>
            </template>
          </el-table-column>
          <!-- 验货地址 -->
          <el-table-column :label="$t('user_Index_YHDZ')" min-width="110">
            <template slot-scope="{ row }">{{row.country+row.province+row.city+row.insp_address}}</template>
          </el-table-column>
          <!-- 距离（KM） -->
          <el-table-column prop="distance" :label="$t('user_Index_JL')" :min-width="yuyan=='en'?110:100"></el-table-column>
          <!-- 验货时长（天数） -->
          <el-table-column prop="insp_day" :label="$t('user_Index_YHSC')" :min-width="yuyan=='en'?110:100"></el-table-column>
          <!-- 已申请人数 -->
          <el-table-column prop="app_num" :label="$t('user_Index_YSQRS')" :min-width="yuyan=='en'?130:100"></el-table-column>
          <!-- 订单状态 -->
          <el-table-column prop="is_app" :label="$t('user_Index_DDZT')" min-width="70">
            <!-- <template slot-scope="{ row }">{{row.is_app==1? $t('user_Index_YAP'):$t('user_Index_WAP')}}</template> -->
            <!-- 等待指派 -->
            <template slot-scope="{ row }">{{flag_msg[row.flag]}}</template>
          </el-table-column>

          <!--审核状态-->
          <el-table-column :label="$t('user_Index_SHZT')" min-width="110" align="center">
            <template slot-scope="scope">
              <div style="position:relative;padding:12px 0">
                <span style="opacity:0;">{{shengheStatus[scope.row.status]}}</span>

                <img
                  width="90"
                  src="../../../assets/images/imgon.png"
                  style="position:absolute;left:7px;top:0;z-index:10"
                  v-if="scope.row.status ===1"
                />
                     <img
                  width="90"
                  src="../../../assets/images/imgyes.png"
                  style="position:absolute;left:7px;top:0;z-index:10"
                  v-else-if="scope.row.status ===2"
                />
                     <img
                  width="90"
                  src="../../../assets/images/imgnext.png"
                  style="position:absolute;left:7px;top:0;z-index:10"
                  v-else-if="scope.row.status ===3"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('user_Index_CAOZUO')" :width="yuyan=='en'?220:120"  align="center">
            <template slot-scope="{ row }">
              <!-- 申请验货  :disabled="row.is_app==1||row.pay_status==1" -->
              <el-button
                type="primary"
                size="mini"
                @click="applyOrder(row)"
              >{{(row.is_app==1||row.pay_status==1)?$t('quxiaoShengqing'):$t('user_Index_SQYH')}}</el-button>

            </template>
          </el-table-column>
          <div slot="empty">
            <p :style="{'marginTop': '23px'}">
              {{$t('ty_zcszd')}}
              <span
                @click="$router.push('/insp/accountManage')"
                style="color: #37aee7;cursor: pointer;"
              >{{$t('ty_zcczd')}}</span>！
            </p>
          </div>
        </el-table>

       <Pagination
                        :total="indexTotal"
                        :pageSize.sync="indexPageSize"
                        :currentPage.sync="indexCurrentPage"
                          @getData="getTableData1"
                         ></Pagination>


        <div v-if="tableData.length==0">
          <div style="overflow:hidden;width:700px;margin:0 auto;">
            <div class="pull-left m-t-50">{{$t('user_Index_SJD')}}</div>
            <div class="pull-right" style="text-align:center;color:#333;">
              <div style="margin-right:30px;display:inline-block;">
                <img style="width:100px;" :src="$host.file+Android_code" />
                <br />
                <span style="line-height:36px">Android App</span>
              </div>
              <div style="display:inline-block;">
                <img style="width:100px" :src="$host.file+ios_code" />
                <br />
                <span style="line-height:36px">Ios App</span>
              </div>
            </div>
          </div>
        </div>
        <el-dialog
          v-dialogDrag
          class="seeyhy"
          :fullscreen="kfglIsFullscreen"
          :title="$t('orderfenbu')"
          style="padding:0;"
          :visible.sync="seeYhY"
          v-if="seeYhY"
          width="60%"
          height="50%"
        >
          <ul class="header-btn-group">
            <!-- <li @click="kfglMask=false,kfglbarIsMin=true">
              <i class="el-icon-minus"></i>
            </li>-->
            <li @click="kfglIsFullscreen=!kfglIsFullscreen">
              <i :class="!kfglIsFullscreen?'el-icon-full-screen':'el-icon-copy-document'"></i>
            </li>
            <li @click="seeYhY=false">
              <i class="el-icon-close"></i>
            </li>
          </ul>
          <div class="amap-wrapper" :style="kfglIsFullscreen ? 'height:800px' :'height:600px'">
            <!-- <el-amap class="amap-box" :center="center" :plugin="plugin" :zoom="zoom" :vid="'amap-vue'">
              <el-amap-marker
                v-for="(marker,index) in markers"
                :key="index"
                :position="marker.position"
                :icon="marker.icon"
                :events="marker.events"
              ></el-amap-marker>
              <el-amap-info-window
                v-if="window"
                :position="window.position"
                :visible="window.visible"
                :content="window.content"
              ></el-amap-info-window>
            </el-amap>-->
            <!-- <baidu-map
              :zoom="zoom"
              :center="{lng: center[0], lat: center[1]}"
              class="amap-box"
              :dragging="true"
              :scroll-wheel-zoom="true"
              style="height:100%;"
              v-if="yuyan==='zh'"
            >
              控件
              <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>
              <bm-map-type
                :map-types="['BMAP_NORMAL_MAP', 'BMAP_HYBRID_MAP','BMAP_SATELLITE_MAP']"
                anchor="BMAP_ANCHOR_TOP_RIGHT"
              ></bm-map-type>
              <bm-scale anchor="BMAP_ANCHOR_BOTTOM_LEFT"></bm-scale>
              <bm-overview-map anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :isOpen="true"></bm-overview-map>
             验货员
              <myOverLay
                v-for="(marker,index) in markers"
                :key="(index+3)*10000"
                :position="{lng: marker.position[0], lat: marker.position[1]}"
                :content="marker.content"
                :events="marker.events"
                :windowData="markers[index]"
                v-on:listenToChildEvent="showMsgfromChild"
              ></myOverLay>
             点击验货员显示的窗口

              <bm-info-window
                v-if="window"
                :position="{lng: window.position[0], lat: window.position[1]}"
                :show="window.visible"
                :content="window.content"
                @close="infoWindowClose"
                @open="infoWindowOpen"
              >
                <div v-html="window.content"></div>
              </bm-info-window>
            </baidu-map> -->
    <!--
            <googleMapUserHome v-else :markers="markers" :myPos="{lng: 116, lat: 39}"></googleMapUserHome> -->



          </div>
        </el-dialog>

       <!-- 提现 -->
        <cash-page :showcash="cashDialog" v-if="cashDialog" @closeCash="closeCash"></cash-page>
        <!-- 提现方式 -->
        <cash-method :showcashmethod="cashmethodDialog" v-if="cashmethodDialog" @close="closeCashmethod" :type="type"></cash-method>
     </div>
    <div v-else>
      <div class="cmain-box"  >
        <!--mobile-->

        <template v-for="(i,index) in tableData">
          <van-cell-group class="vg-box" inset>
            <van-cell :title="i.orders_num"   />

            <div class="row-b-box">
              <div class="lsbox">
                {{$t('user_Index_XDRQ')}} :
                <span>{{i.add_time}}</span>
              </div>
              <div class="lsbox">
                {{$t('user_Index_YHLX')}} :
                <span>{{i.type==1?$t('user_Index_CJ'):i.type==2?$t('user_Index_QJ'):i.type==3?$t('user_Index_ZXJY'):i.type==4?$t('user_Index_YC'):i.type==5?$t('user_Index_JG'):$t('user_Index_YH+JG')}}</span>
              </div>
              <div class="lsbox">
                {{$t('user_Index_CPMC')}} :
                <span
                    v-for="(item,index) in i.products"
                    :key="index"
                >{{index!==i.products.length-1? item.product_name?item.product_name:'N/A'+',':item.product_name?item.product_name:'N/A'}}</span>
                <span v-if="i.products.length == 0">N/A</span>
              </div>
              <div class="lsbox">
                {{$t('user_Index_YHSJ')}} :
                <span>{{i.inspect_time}}</span>
              </div>
              <div class="lsbox">
                {{$t('user_Index_JL')}} :
                <span>{{i.distance}}</span>
              </div>
              <div class="lsbox">

                {{i.country+i.province+i.city+i.insp_address}}

              </div>
              <div class="lsbox" style="text-align:right;padding-top:10px">
                <!-- 申请验货  :disabled="row.is_app==1||row.pay_status==1" -->
                <el-button
                    type="primary"
                    size="mini"
                    @click="applyOrder(i)"
                >{{(i.is_app==1||i.pay_status==1)?$t('quxiaoShengqing'):$t('user_Index_SQYH')}}</el-button>

              </div>
            </div>

            <div class="ostatus-text-box" :class="'flag-status-'+i.flag">
              {{flag_msg[i.flag]}}
            </div>


          </van-cell-group>
        </template>

      </div>
      <b-menu></b-menu>
    </div>
    <!-- 申请验货 -->
    <el-dialog v-dialogDrag :title="$t('user_Index_SQYH')"  v-if='applyVis' :visible.sync="applyVis" :width="$flag?'90%':'560px'">
      <div style="text-align:center;">
        <!-- 验货费用 -->
        <p style="margin-bottom:20px;color:#898989">{{$t('psmsg1')}}</p>
        <span >{{$t('user_Index_YHFY')}}：</span>
        <!-- <el-input v-model.number="money" :min="0" style="width: 200px"></el-input> -->

        <!-- ￥<el-input v-model="RBM" @input="TBMoney($event,'RMB')" style="width:120px;margin-right:5px;"></el-input>
          <span style="position:relative;">
            <i class="el-icon-sort" style="transform: rotate(90deg);"></i>
            <span style="position: absolute;top: -21px;left: 50%;">{{rate}}</span>
          </span>
        $<el-input v-model="money" @input="TBMoney($event,'US')" style="width:120px;margin-left:5px;"></el-input>-->

        <!--  <el-input
            v-model="RBM"
            @input="TBMoney($event,'RMB')"
            style="width:260px;margin-right:5px;vertical-align: middle;"

          >
            <template slot="append">{{$t('user_Index_RMB')}}(CNY)</template>
          </el-input> -->

        <!--mydev-->
        <el-input  v-if="account==1"   @input="TBMoney($event,'RMB')" v-model="RBM" style="width:180px;margin-right:5px;vertical-align: middle;">
          <el-select style="width:90px;" v-model="account"  slot="prepend" placeholder="请选择">
            <el-option :label="$t('user_Index_RMB')" :value="1"></el-option>
            <el-option :label="$t('user_Index_MY')" :value="2"></el-option>

          </el-select>

        </el-input>
        <el-input  v-else  @input="TBMoney($event,'US')" v-model="money" style="width:180px;margin-right:5px;vertical-align: middle;">
          <el-select style="width:90px;" v-model="account"   slot="prepend" placeholder="请选择">
            <el-option :label="$t('user_Index_RMB')" :value="1"></el-option>
            <el-option :label="$t('user_Index_MY')" :value="2"></el-option>

          </el-select>

        </el-input>
        <p v-if="account==1" style="margin-top:10px;color:#898989">{{$t('todayHuilu')}} {{rate}}，{{$t('zheheRMB')}}USD {{Number(money).toFixed(2)}}</p>
        <p v-else style="margin-top:10px;color:#898989">{{$t('todayHuilu')}} {{rate}}，{{$t('zheheUSB')}}RMB {{RBM}}</p>



        <div class="mark-box m-mark-box" v-if="$flag">
          <div class="yl-label">{{$t('留言')}}：</div>
          <div class="mark-text">
            <el-input
                      type="textarea"
                      :rows="2"
                      :placeholder="$t('请输入留言')"
                      v-model="mark">
            </el-input>
          </div>

        </div>
        <div class="mark-box" v-else>
          <div style="width:300px;padding-bottom:10px;">{{$t('留言')}}：</div>
          <div class="mark-text">
            <el-input style="width:200px"
                      type="textarea"
                      :rows="2"
                      :placeholder="$t('请输入留言')"
                      v-model="mark">
            </el-input>
          </div>

        </div>

        <!--  <span style="position:relative;text-align:center;">
            <img style="width:70px;height:20px;" src="../../../assets/images/change.png" alt />
            <span
              class="fs-14"
              style="position: absolute;top: -21px;display: inline-block;width: 70px;text-align: center;left: 0;"
            >{{rate}}</span>
            <span
              style="position: absolute;top: 14px;left: 50%;margin-left: -28px;"
              @click="openRate()"
              class="fs-14 text-blue cursor-pointer"
            >{{$t('user_Index_JRHL')}}</span>
          </span> -->
        <!--  <el-input
           v-model="money"
           @input="TBMoney($event,'US')"
           style="width:150px;margin-left:5px;"
         >
           <template slot="prepend">$</template>
         </el-input> -->

        <p style="margin-top:25px">
          <el-checkbox style="vertical-align:middle" v-model="isTongyi"><span style="color:#898989">{{$t('zsbzx')}}</span></el-checkbox>
          <router-link target="_blank" tag='a' to='/insp/instructions'  style="color:#0a3cfd;margin-left:5px;vertical-align:-1px" >{{$t('yhyz')}}</router-link>
        </p>
      </div>
      <div slot="footer" class="dialog-footer">
        <!-- 取消、确定 -->
        <el-button @click="isTongyi = false,applyVis=false" class="button-radius-5px">{{$t('user_Index_QX')}}</el-button>
        <el-button
            type="primary"
            class="button-radius-5px"
            :disabled="isTongyi==false"
            @click="submitApply"
        >{{$t('user_Index_QD')}}</el-button>
      </div>
    </el-dialog>

  </div>


</template>

<script>
import myOverLay from "@/components/myOverLay";
import googleMapUserHome from '@/components/googleMapUserHome'
import bMenu from '@/components/bMenu'
import {
  userInfo,
  insp,
  add_insp,
  inspector,
  integralManagement
} from "@/Inspector_api/index";
import { service } from "@/api/login.js";
import check from "@/check/check";
import cashPage from "@/components/cash.vue";
import cashMethod from "@/components/cashmethod.vue";
import { rate } from "@/api/customerManagementAdd";
import { app_record, withdraw } from "@/Inspector_api/index";
import $ from "jquery";
export default {
  components: {
    cashPage,
    cashMethod,
    myOverLay,
    googleMapUserHome,
    bMenu
  },
  computed: {
    menus() {
      let menu = [
        {
          label: this.$t("user_Index_FJYH"), //附近验货
          name: "nearby"
        }
      ];
      return menu;
    }
  },
  data() {
    return {
      btype:"RMB",
      indexTotal:0,
      indexPageSize:10,
      indexCurrentPage:1,//当前页
      // 等级
      isTongyi:false,//是否同意
      addList:[],
      zoom:5,
      kfglIsFullscreen: false,
      seeYhY: false,
      gradeVis: false,
      integralVis: false,
      type: "salesman",
      Android_code: "",
      ios_code: "",
      userInfo: {
        grade: 3, //等级
        integral: "11", //积分
        credit_grade: "2", //信用等级
        amount: 0,
        us_amount: 0,
        amount_type: 1
      },
      tableData: [],
      type: "nearby",
      applyVis: false,
      money: "", //验货费用
      order_id: "", //订单id
      inspector: [], //验货员列表
      center: [121.59996, 31.197646],
      zoom: 16,
      markers: [],
      windows: [],
      window: "",
      plugin: [
        {
          pName: "Scale"
        },
        {
          pName: "ToolBar"
        },
        {
          pName: "Autocomplete"
        },
        {
          pName: "MapType"
        },
        {
          pName: "OverView",
          isOpen: true
        }
      ],
      //提现
      cashDialog: false,
      // 提现方式
      cashmethodDialog: false,
      RBM: 0,
      rate: 0,
      rowMoney: 0, //当前验货费用
	  user_account:1,//费用类型
      message: "",
      integralData: [],
      notify: "",
      flag_msg: {
        1: this.$t("caogao"),
        2: this.$t("user_Index_DPD"),
        3: this.$t("daishishi"),
        4: this.$t("user_Index_YWC"),
        5: this.$t("user_Index_YTH")
      }, //订单状态
      shengheStatus: {
        0: "",
        1: this.$t('shengqingzhong'),
        2: this.$t('yipaidan'),
        3: this.$t('xiacehezuo')
      },
      
      handleType: "shengqing" ,//shengqing=>申请 else=>取消
	  account:1,
	  mark:""
    };
  },
  watch: {
    applyVis(val) {
      if (!val) {
        if (this.message) {
          this.message.close();
        }
      }
    }
  },
  beforeDestroy() {
    this.notify = null;
  },
  methods: {
	choose_account(){
	   this.btype=this.account==1?'RMB':"US";
		   console.log(this.btype);
	   this.TBMoney(0,this.btype); 
	},
    getPosition(){
      let that = this
       $.ajax({
        type: "get",
        async: false,
        dataType: "jsonp", //数据类型为jsonp
        jsonp: "callback", //服务端用于接收callback调用的function名的参数
        url: `https://api.map.baidu.com/place/v2/search?query=${this.userInfo.address}&region=全国&output=json&ak=1t9UlXXxADY0UH5tb87AdcLikwtfjNtC&scope=2`,
        success: function(data) {
          console.log(data)
           that.addList = data.results.map(item => {
            item.value = item.name;
            return item;
          });
          // cb(addList);
        },
        error: function(e) {
          check.error(that, "地图调用失败!");
        }
      });
    },
    //获取当前有几条订单未确认
    async getNo(value) {
	  if(this.$flag){
	    return;
    }
      let _this = this;
      this.notify = this.$notify.info({
        title: _this.$t("ty_ts"),
        duration: 3000,
        dangerouslyUseHTMLString: true,
        message:
          `<span style="padding-left:10px;">` +
          _this.$t("ty_ny") +
          value +
          _this.$t("ty_wqr") +
          `<a style="color: #61c3ff;cursor: pointer;">` +
          _this.$t("ty_ljqw") +
          `</a></span>`
      });
      this.notify.$el.querySelector("span").onclick = () => {
        this.$router.push("/insp/orderManage");
        this.notify.close();
      };
    },
    //获取积分列表
    async getTableData() {
      let list = {};
      list["page"] = this.page_current;
      list["page_size"] = this.page_size;
      const res = await integralManagement(list);
      const { code, data } = res.data;
      if (code == 200) {
        this.integralData = data.data.list;
        this.page_total = data.data.total_num;
      }
    },
    openRate() {
      let path = "https://finance.sina.com.cn/money/forex/hq/USDCNY.shtml";
      let locale = localStorage.getItem("locale");
      locale != "zh"
        ? (path = "https://usd.fxexchangerate.com/")
        : (path = "https://finance.sina.com.cn/money/forex/hq/USDCNY.shtml");
      window.open(path, "_blank");
    },
    async getRate() {
      const res = await rate();
      const { code, data, msg } = res.data;
      if (code == 200) {
        this.rate = data;
      }
    },
    TBMoney(val, val1) {
      if (val1 == "RMB") {
        this.money = Number((this.RBM / this.rate).toFixed(2));
      } else {
        this.RBM = Number((this.money * this.rate).toFixed(2));
      }
    },
    // async getService() {
    //   const res = await service();
    //   let { code, data } = res.data;
    //   this.Android_code = data.Android_code;
    //   this.ios_code = data.ios_code;
    // },
    showMsgfromChild(data) {
      let e = data.data;
      if (e.is_app == 1 || e.pay_status == 1) {
        this.$message.error("已申请");
        return;
      } else {
        this.applyOrder(e);
      }
      // this.window = data
    },
    infoWindowClose(e) {
      this.window.visible = false;
    },
    infoWindowOpen(e) {
      this.window.visible = true;
    },
    changeRouter(index) {
      this.type = this.menus[index].name;
      this.getTableData1();
    },
    //获取用户信息
    async getuserInfo(val) {
      this.$store.dispatch("global/getUserinfo")
      this.userInfo = this.userInfo;
      this.money = this.userInfo.us_inspection_fee;
      this.$store.commit("global/set_userInfo", this.userInfo);
      if (this.userInfo.tips > 0) {
        this.getNo(this.userInfo.tips);
      }
      // const res = await userInfo();
      // const { code, data } = res.data;
      // if (code == 200) {
      //   this.userInfo = data.data;
      //   this.money = data.data.us_inspection_fee;
      //   this.$store.commit("global/set_userInfo", data.data);
      //   if (data.data.tips > 0) {
      //     this.getNo(data.data.tips);
      //   }
      //   localStorage.setItem("userInfo", JSON.stringify(data.data));
        if (val) {
          this.cashmethodDialog = true;
        }
      // }
    },
    //验货列表
    async getTableData1() {
      const res = await insp({ type: this.type,page:this.indexCurrentPage,page_size:this.indexPageSize });
      const { code, data } = res.data;
      if (code == 200) {

        this.tableData = data.list || [];
        this.indexTotal = data.total_num;
        // 附近订单 按距离排序
        // if (this.type == "nearby") {
        //   this.tableData.sort(this.compare("distance"));
        // }
        // 获取手机二维码提示
        if (this.type == "nearby" && this.tableData.length == 0) {
          // this.getService();
          const _this = this
          this.$store.dispatch('global/getCustomer').then(() => {
            _this.Android_code = _this.$store.state.global.KefuInfo.Android_code;
            _this.ios_code = _this.$store.state.global.KefuInfo.ios_code;
          });
        }
        // 将订单展示在地图里
        if (this.tableData.length >= 1) {
          if(this.addList[0]){
             this.center = [ parseFloat(this.addList[0].location.lng),parseFloat(this.addList[0].location.lat)];
          }else{
            this.center = []
          }
         
          this.zoom = 6;
          let markers = [];
          markers[0] = {
            content: `<div style="border-radius:50%;overflow:hidden;">
              <div style="position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              border-radius: 50%;"></div>
              <img style="width:40px;height:40px;" src="${this.$host.file +
                this.userInfo.head}"></div>`,
              // position: [parseFloat(this.addList[0].location.lng), parseFloat(this.addList[0].location.lat)],
              position: this.center,
          }
          let windows = [];
          let self = this;
          let point = [];
          this.tableData.forEach((e, index) => {
            markers.push({
              content: `<div style="width:20px;height:20px;border-radius:50%;background-color:${
                e.is_app == 1 || e.pay_status == 1 ? "#979595" : "red"
              };"></div>`,
              position: [parseFloat(e.lon), parseFloat(e.lat)],
              events: {
                click() {
                  // self.windows.forEach(window => {
                  //   window.visible = false;
                  // });
                  // self.window = self.windows[index];
                  // self.$nextTick(() => {
                  //   self.window.visible = true;
                  // });
                }
              },
              data: e
            });
            // windows.push({
            //   position: [parseFloat(e.lon), parseFloat(e.lat)],
            //   // position: [parseFloat(point[0]), parseFloat(point[1])],
            //   content: `<div class="prompt clearfixed fs-12"><div class="pull-left w-70 text-center"><img src="${this.$host.file+e.head}" class="b-round" width="40px" height="40px"></div><div class="pull-left w-150 lh-20"><p>${e.nick}</p><p>城市：${e.city}</p></div></div>`,
            //   visible: false
            // });
          });
          this.markers = markers;
          // this.windows = windows;
        } else {
          this.markers = [];
          this.windows = [];
        }
      }
    },
    // 降序
    //定义一个比较器--降序排列
    compare(propertyName) {
      return function(object1, object2) {
        var value1 = object1[propertyName];
        var value2 = object2[propertyName];
        // if(value2 < value1) {
        //     return -1;
        // } else if(value2 > value1) {
        //     return 1;
        // } else {
        //     return 0;
        // }
        return value1 - value2;
      };
    },
    //申请记录
    toApplyRecod() {
      this.$router.push({
        path: "/insp/applyRecod"
      });
    },
    //申请验货
    async applyOrder(row) {
      this.order_id = row.order_id;
      this.money = this.userInfo.us_inspection_fee
        ? this.userInfo.us_inspection_fee
        : 0;
      this.RBM = Number((this.money * this.rate).toFixed(2));
      this.rowMoney = row.price ? row.price : 0;
	  this.user_account=row.user_account;
      if (row.is_app == 1 || row.pay_status == 1) {
        this.handleType = "quxiao";
        const res = await withdraw({ order_id: this.order_id });
        const { code, data, msg } = res.data;
        if (code == 200) {
          this.$message.success(msg);
          this.getTableData1();
        } 
      } else {
        this.handleType = "shengqing";
        this.isTongyi = false;
        this.applyVis = true;
    
      }
    },
    //确认申请验货
    async submitApply() {
      if(!this.isTongyi){
       this.$message.error(this.$t("qtysyxz"));
       return;
      }
      if (this.money == 0 || check.isEmpty(this.money)) {
        this.$message.error(this.$t("ty_sryhfy"));
        return;
      }
      if (check.isNumber(this.money)) {
        this.$message.error(this.$t("ty_qsrsz"));
        return;
      }
	   var mb=this.user_account==1?this.RBM:this.money;
      if (mb >= Number(this.rowMoney)) {
        this.$message.error(this.$t("ty_fygo"));
        return;
      }
	  //mydev
      const res = await add_insp({
        order_id: this.order_id,
        money: this.account==1?this.RBM:this.money,
		account:this.account,
		mark:this.mark
      });
      const { code, data, msg } = res.data;
      if (code == 200) {
        this.$message.success(msg);
        this.applyVis = false;
        this.getTableData1();
        this.getuserInfo();
      } else if (code == 402) {
        //跳转到用户设置
        if (msg == "认证信息审核中" || msg == "未获取授权") {
          this.message = this.$message({
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: msg,
            type: "error",
            duration: 0
          });
        } else {
          this.message = this.$message({
            showClose: true,
            dangerouslyUseHTMLString: true,
            message:
              msg +
              `<a style="padding-left:10px;">` +
              this.$t("ty_ljqw") +
              `<router-link style="color: #61c3ff;cursor: pointer;"> ` +
              this.$t("user_Index_ZHSZ") +
              `</router-link></a>`,
            type: "error",
            duration: 0
          });
        }

        this.message.$el.querySelector("a").onclick = () => {
          this.$router.push("/insp/accountManage");
          this.message.close();
        };
      }
    },
    //验货员地图列表
    async getinspector() {
      const res = await inspector();
      const { code, data } = res.data;
      if (code == 200) {
        this.inspector = data ? data : [];
        if (this.inspector.length >= 1) {
          // let arr = this.inspector[0].long_lat.split(",");
          // this.center = [parseFloat(arr[0]), parseFloat(arr[1])];
          this.center = [
            parseFloat(this.inspector[0].lon),
            parseFloat(this.inspector[0].lat)
          ];
          let markers = [];
          let windows = [];

          let self = this;
          let point = [];
          this.inspector.forEach((e, index) => {
            // point = e.long_lat.split(",");
            markers.push({
              // position: [parseFloat(point[0]), parseFloat(point[1])],
              // icon: this.$host.file+e.head,
              content: `<div style="border-radius:50%;overflow:hidden;">
              <img style="width:40px;height:40px" src="${this.$host.file +
                e.head}"></div>`,
              position: [parseFloat(e.lon), parseFloat(e.lat)],
              events: {
                click() {
                  self.windows.forEach(window => {
                    window.visible = false;
                  });

                  self.window = self.windows[index];
                  self.$nextTick(() => {
                    self.window.visible = true;
                  });
                }
              }
            });
            windows.push({
              position: [parseFloat(e.lon), parseFloat(e.lat)],
              // position: [parseFloat(point[0]), parseFloat(point[1])],
              content: `<div class="prompt clearfixed fs-12"><div class="pull-left w-70 text-center"><img src="${this
                .$host.file +
                e.head}" class="b-round" width="40px" height="40px"></div><div class="pull-left w-150 lh-20"><p>${
                e.nick
              }</p><p>城市：${e.city}</p></div></div>`,
              visible: false
            });
          });
          this.markers = markers;
          this.windows = windows;
        } else {
          this.markers = [];
          this.windows = [];
        }
      }
    },
    //提现
    closeCash(text) {
      this.cashDialog = text.val;
      if (text.type == 2) {
        this.getuserInfo();
      }
    },
    //提现方式
    closeCashmethod(text) {
      console.log(text);
      this.cashmethodDialog = text.val;
      if (text.type == 2) {
        this.getuserInfo();
      }
    }
  },
  async created() {
    this.userInfo = this.$store.state.global.userInfo
    this.money = this.userInfo.us_inspection_fee;
    this.$store.commit("global/set_userInfo", this.userInfo);
    if (this.userInfo.tips > 0) {
      this.getNo(this.userInfo.tips);
    }
    // this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    await this.getRate();
    await this.getuserInfo();
    await this.getPosition()
    await this.getTableData1();
    
    
  },
  mounted() {
    this.notify = null;
    // this.getinspector();
    window.changeRouter = this.changeRouter;
  }
};
</script>


<style lang="scss" scoped>
.hover{
  cursor: pointer;
  &:hover{
    color:#FA7202
  }
}
.org {
  color: $--color-primary;
}
.borwn {
  color: #90613a;
}
.title /deep/ .el-card__body {
  padding: 12px;
}
.amount /deep/ .el-card__body {
  padding: 10px;
}
.levelInfo /deep/ .el-card {
  height: 110px;
}
/deep/ .subMenu {
  background-color: #ffffff;
}
.amap-wrapper {
  // width: 99%;
  height: 600px;
}
/deep/ .seeyhy .el-dialog__body {
  padding: 0;
}
.amap-icon {
  /* border-radius: 50% !important; */
  /* overflow: hidden !important; */
}
/deep/ .amap-icon img {
  width: 50px !important;
  height: 50px !important;
  border-radius: 50%;
  border: 2px solid #fa7202;
}
</style>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px !important;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.el-card {
  box-shadow: 0px 0px 6px #eee;
}

.header-btn-group {
  position: absolute;
  right: 17px;
  top: 10px;
  z-index: 100;
  display: inline-block;
  width: 150px;
  text-align: right;
}
.header-btn-group li {
  display: inline-block;
  margin-left: 12px;
  font-size: 18px;
  color: #fff;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  padding: 4px;
}
.mark-box{
	padding-top:20px;
	position:relative;
	height:120px;
}
.mark-text{
	position:absolute;
	left:170px;
	top:15px;
}
</style>